export default __webpack_public_path__ + "static/media/image.oak-integrated-systems-pvt-ltd.f1bb1931.png";